import { normalizeFileName } from "../../utils/file";
import { toastError } from "../../utils/toast";
import { useCallback, useState } from "react";
import type { AttachmentFile } from "../../components/redline/attachment-file";

export interface UseFileAttachmentsInputs {
  attachmentFiles: AttachmentFile[];
  handleRemoveFilesClick: (index: number) => void;
  handleDeleteFileConfirm: () => Promise<void>;
}

export function useFileAttachments({ attachmentFiles, handleRemoveFilesClick, handleDeleteFileConfirm }: UseFileAttachmentsInputs) {
  const [showDeleteFileDialog, setShowDeleteFileDialog] = useState(false);
  const [fileToDelete, setFileToDelete] = useState<{ id: string; fileName: string } | null>(null);
  const handleDeleteFileCancel = useCallback(() => {
    setShowDeleteFileDialog(false);
    setFileToDelete(null);
  }, []);
  const handleRemoveFilesClickWrapper = useCallback((index: number) => {
    const file = attachmentFiles[index];
    if (!file) return;

    setFileToDelete({ id: file.id, fileName: file.fileName });
    setShowDeleteFileDialog(true);
    handleRemoveFilesClick(index);
  }, [attachmentFiles, handleRemoveFilesClick]);
  const handleDeleteFileConfirmWrapper = useCallback(async () => {
    if (!fileToDelete) return;
    setShowDeleteFileDialog(false);
    setFileToDelete(null);

    try {
      await handleDeleteFileConfirm();
    } catch (error) {
      toastError(error);
    }
  }, [fileToDelete, handleDeleteFileConfirm]);
  const handleRemoveSavedFileWrapper = useCallback((fileName: string) => {
    const attachmentIndex = attachmentFiles.findIndex(file => normalizeFileName(file.fileName) === normalizeFileName(fileName));
    if (attachmentIndex !== -1) {
      handleRemoveFilesClickWrapper(attachmentIndex);
    }
  }, [attachmentFiles, handleRemoveFilesClickWrapper]);
  return { showDeleteFileDialog, fileToDelete, handleDeleteFileCancel, handleRemoveFilesClickWrapper, handleDeleteFileConfirmWrapper, handleRemoveSavedFileWrapper };
}
